import React, { useEffect } from "react";
import { Form, Input, Select, Button, DatePicker } from "antd";
import {
  createDataElementForm,
  updateDataElementForm,
} from "../../actions/admin";
import { useDispatch, useSelector } from "react-redux";
import TextArea from "antd/es/input/TextArea";
import CategoryListing from "../../components/Comman/DropdownsListing/CategoryListing";
import { dataelementsIntervals } from "../../utils/comman";
import dayjs from "dayjs";

const { Option } = Select;

interface SideDrawerProps {
  dataElementData?: any; // Optional organization data
  open?: boolean;
  onClose?: any;
}

const CreateDataElements: React.FC<SideDrawerProps> = ({
  dataElementData,
  open,
  onClose,
}) => {
  const [form] = Form.useForm();
  const dispatch: any = useDispatch();
  const loadingGlobal = useSelector((state: any) => state?.General);

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open]);

  const onFinish = async (values: any) => {
    values.DataElements_StartingDueDate = values?.DataElements_StartingDueDate
      ? dayjs(values.DataElements_StartingDueDate).format("YYYY-MM-DD")
      : undefined;

    if (dataElementData?.id) {
      const payload = { ...values, budgetId: dataElementData?.id };
      dispatch(
        updateDataElementForm(payload, (resp: any) => {
          if (resp?.status === 200 || resp?.status === 201) {
            form.resetFields(); // Clear form on successful submission
            onClose();
          }
        })
      );
    } else {
      dispatch(
        createDataElementForm(values, (resp: any) => {
          if (resp?.status === 200 || resp?.status === 201) {
            form.resetFields(); // Clear form on successful submission
            onClose();
          }
        })
      );
    }
  };

  useEffect(() => {
    // if (Object.entries(dataElementData).length || (open && dataElementData)) {
    if (Object.entries(dataElementData).length) {
      form.setFieldsValue({
        DataElements_Name: dataElementData?.DataElements_Name || "",
        DataElements_Description:
          dataElementData?.DataElements_Description || "",
        DataElements_XDescription:
          dataElementData?.DataElements_XDescription || "",
        DataElements_IsBudgeted: dataElementData?.DataElements_IsBudgeted,
        DataElements_DataType: dataElementData?.DataElements_DataType,
        DataElements_StartingDueDate: Object.entries(dataElementData).length
          ? dayjs(dataElementData.DataElements_StartingDueDate)
          : null,
        Interval_ID: dataElementData?.Interval_ID || null,
        DataElements_IsCalculated: dataElementData?.DataElements_IsCalculated,
        DataElements_IsRollUp: dataElementData?.DataElements_IsRollUp,
        categoryId: dataElementData?.categoryId || null,
      });
    } else {
      form.resetFields();
    }
  }, [dataElementData, open, form]);

  const handleDateChange = (date, dateString) => {
    // No need for additional moment wrapping - Ant Design's DatePicker
    // already returns a properly formatted moment object
    form.setFieldsValue({
      DataElements_StartingDueDate: date,
    });
  };
  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <div className="mb-[20px]">
        <CategoryListing dataToSet={dataElementData} />
      </div>
      <div className="mb-[20px]">
        <Form.Item
          name="DataElements_Name"
          rules={[{ required: true, message: "Please enter element name" }]}
        >
          <Input
            placeholder="Data Element Name"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[15px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#fff] color-[#fff]"
          />
        </Form.Item>
      </div>
      <div className="mb-[20px]">
        <Form.Item
          name="DataElements_Description"
          rules={[{ required: true, message: "Please enter description" }]}
        >
          <TextArea
            showCount
            maxLength={200}
            placeholder="Data Element Description"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[15px]  border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff]"
          />
        </Form.Item>
      </div>
      <div className="mb-[20px]">
        <Form.Item
          name="DataElements_XDescription"
          rules={[{ required: true, message: "Please enter XDescription" }]}
        >
          <TextArea
            showCount
            maxLength={200}
            placeholder="Data Element XDescription"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[15px]  border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff]"
          />
        </Form.Item>
      </div>
      <div className="mb-[20px]">
        <Form.Item
          name="DataElements_IsBudgeted"
          rules={[{ required: true, message: "Please select a value" }]}
        >
          <Select
            placeholder="Is Budgeted(Yes/No)"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
          >
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>
          </Select>
        </Form.Item>
      </div>
      <div className="mb-[20px]">
        <Form.Item
          name="DataElements_DataType"
          rules={[{ required: true, message: "Please select a data type" }]}
        >
          <Select
            placeholder="Data Type"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
          >
            {/* <Option value={""}>Data Type</Option> */}
            <Option value={"Money"}>Money</Option>
            <Option value={"Decimal"}>Decimal</Option>
            <Option value={"Integer"}>Integer</Option>
            <Option value={"Percent"}>Percent</Option>
          </Select>
        </Form.Item>
      </div>

      {/* <Form.Item
        name="DataElements_StartingDueDate"
        rules={[{ required: true, message: "Please select a date" }]}
      >
        <DatePicker
          placeholder="Day of Month (DOM)"
          className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
          onChange={handleDateChange}
        />
      </Form.Item> */}

      <div className="mb-[10px]">
        <Form.Item
          name="DataElements_StartingDueDate"
          rules={[{ required: true, message: "Please select a date" }]}
        >
          <DatePicker
            placeholder="Day of Month (DOM)"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto placeholder-white"
            onChange={handleDateChange}
            // format="YYYY-MM-DD" // Add explicit format
            // If you want to disable rendering of dates that already appear
            // you can add a disabledDate function
            disabledDate={(current) => {
              // This is optional, but can help if you have validation requirements
              // Example: prevent selection of past dates
              // return current && current < moment().startOf('day');
              return false;
            }}
          />
        </Form.Item>
      </div>

      <div className="mb-[20px]">
        <Form.Item
          name="Interval_ID"
          rules={[{ required: true, message: "Please select a interval" }]}
        >
          <Select
            placeholder="Submission Interval"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
          >
            {dataelementsIntervals?.map((data, key) => (
              <Option key={data?.id} value={data?.id} disabled={data?.id === 6}>
                {data?.Interval_Name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
      <div className="mb-[20px]">
        <Form.Item
          name="DataElements_IsCalculated"
          rules={[{ required: true, message: "Please select a value" }]}
        >
          <Select
            placeholder="Is Calculated?(Yes/No)"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
          >
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>
          </Select>
        </Form.Item>
      </div>
      <div className="mb-[20px]">
        <Form.Item
          name="DataElements_IsRollUp"
          rules={[{ required: true, message: "Please select a value" }]}
        >
          <Select
            placeholder="Does This DE Roll Up?(Yes/No)"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
          >
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>
          </Select>
        </Form.Item>
      </div>

      <div className="mb-[20px]">
        <Form.Item>
          <Button
            htmlType="submit"
            className="p-[25px] text-[12px] w-full text-white rounded-md gradient-button"
            loading={loadingGlobal?.isLoading}
          >
            {Object.keys(dataElementData)?.length > 0 ? "Update" : "Submit"}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};

export default CreateDataElements;
